import React from 'react';
import { BottomModalContent } from './BottomModalContent/BottomModalContent.es.js';
import { CenteredModalContent } from './CenteredModalContent/CenteredModalContent.es.js';
import { FullscreenModalContent } from './FullscreenModalContent/FullscreenModalContent.es.js';

var ModalContent = function ModalContent(props) {
  var children = props.children,
      layout = props.layout,
      open = props.open,
      onClose = props.onClose,
      title = props.title,
      titleHTML = props.titleHTML,
      alwaysShowTitle = props.alwaysShowTitle,
      closeButton = props.closeButton,
      absoluteHeader = props.absoluteHeader,
      navBottomElement = props.navBottomElement,
      hideHeader = props.hideHeader,
      onShowTransitionStart = props.onShowTransitionStart,
      onShowTransitionEnd = props.onShowTransitionEnd,
      onHideTransitionStart = props.onHideTransitionStart,
      onHideTransitionEnd = props.onHideTransitionEnd,
      customNavbar = props.customNavbar;

  if (['fullscreen', 'fullscreen-narrow', 'fullscreen-wide'].includes(layout)) {
    return /*#__PURE__*/React.createElement(FullscreenModalContent, Object.assign({}, {
      customNavbar: customNavbar,
      open: open,
      title: title,
      alwaysShowTitle: alwaysShowTitle,
      layout: layout,
      hideHeader: hideHeader,
      closeButton: closeButton,
      absoluteHeader: absoluteHeader,
      navBottomElement: navBottomElement,
      onClose: onClose,
      onShowTransitionStart: onShowTransitionStart,
      onShowTransitionEnd: onShowTransitionEnd,
      onHideTransitionStart: onHideTransitionStart,
      onHideTransitionEnd: onHideTransitionEnd,
      children: children
    }));
  }

  if (layout === 'centered' || layout === 'centered-auto') {
    return /*#__PURE__*/React.createElement(CenteredModalContent, Object.assign({}, {
      open: open,
      onClose: onClose,
      children: children,
      closeButton: closeButton,
      hideHeader: hideHeader,
      onShowTransitionStart: onShowTransitionStart,
      onShowTransitionEnd: onShowTransitionEnd,
      onHideTransitionStart: onHideTransitionStart,
      onHideTransitionEnd: onHideTransitionEnd,
      isAuto: layout === 'centered-auto'
    }));
  }

  if (layout === 'bottom') {
    return /*#__PURE__*/React.createElement(BottomModalContent, Object.assign({}, {
      open: open,
      title: title,
      titleHTML: titleHTML,
      onClose: onClose,
      children: children,
      closeButton: closeButton,
      hideHeader: hideHeader,
      onShowTransitionStart: onShowTransitionStart,
      onShowTransitionEnd: onShowTransitionEnd,
      onHideTransitionStart: onHideTransitionStart,
      onHideTransitionEnd: onHideTransitionEnd
    }));
  }

  throw new TypeError("Unknown ModalContent.props.layout: ".concat(layout));
};
ModalContent.defaultProps = {
  open: true,
  layout: 'fullscreen'
};

export { ModalContent };
